import { MetricDefinitionConstants } from './MetricDefinition.constants';
import Api from './MetricDefinition.api';
import { message } from 'antd';
import { t } from 'i18next';
import _ from 'lodash';
const MetricDefinition = new Api('', 'sphere');

// --- Error Handller
const handleError = error => {
  const statusFirstDigit = error && (error.status / 100) >> 0;

  if (statusFirstDigit === 4 || statusFirstDigit === 5) {
    if (error.response && error.response.data && error.response.data.detail) {
      message.error(error.response.data.detail);
    } else {
      message.error(t('GRAAS_SOMETHING_WENT_WRONG_GRAAS'));
    }
  }
};

export const getMetricDefinition = payload => {
  let apiData = {};
  let errorObj = {};
  return async dispatch => {
    try {
      apiData = await MetricDefinition.getMetricDefinition(payload);
      if (apiData && apiData?.hasError) {
        errorObj = apiData;
        throw new Error(errorObj);
      } else {
        dispatch({ type: MetricDefinitionConstants.GET_METRIC_DEFINITION, payload: apiData?.data });
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const getChromeMetrics = (props) => async dispatch => {
  try {
    const response = await MetricDefinition.getChromeMetricDefinition(props);
    if (response?.status === 'success') {
      dispatch({
        type: MetricDefinitionConstants.GET_CHROME_METRICS_SUCCESS,
        payload: response
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export const getMetricDimensionMappingViaSphere = (props) => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: MetricDefinitionConstants.GET_MAPPING_REQUEST });
      apiData = await MetricDefinition.getMetricDimensionMapping(props);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        let formattedData = data?.data || [];
        let metricsDisplayNameMapping = getMetricsAndDisplayNameMapping(formattedData);
        dispatch({ type: MetricDefinitionConstants.GET_MAPPING_SUCCESS, payload: formattedData });
        dispatch({
          type: MetricDefinitionConstants.UPDATE_METRICS_DISPLAY_MAPPING,
          payload: metricsDisplayNameMapping
        });
      }
    } catch (error) {
      dispatch({ type: MetricDefinitionConstants.GET_MAPPING_ERROR });
    }
  };
};

const getMetricsAndDisplayNameMapping = dataList => {
  // Create a combined map with lodash
  const combinedMap = _.reduce(
    dataList,
    (acc, metricObj) => {
      // Add the main metric name and display name
      acc[metricObj.metric_name] = metricObj.display_name;

      // Add each dimension name and display name if not already added
      _.forEach(metricObj.dimension, dimension => {
        if (!acc[dimension.dimension_name]) {
          acc[dimension.dimension_name] = dimension.display_name;
        }
      });

      return acc;
    },
    {}
  );
  return combinedMap;
};
